<template>
  <v-container>
    <v-row justify="end">
      <RequiredItemText/>
    </v-row>
    <v-row>
      <FormItem :name="`${label('image')}(${imageCount}/3)`">
        <div class="d-flex flex-row">
          <v-img
            v-if="image1Url"
            :src="image1Url"
            width="240px"
            max-height="135px"
            class="ma-2 imageView elevation-2"
          >
            <v-icon class="imageClose" @click="onClearImage(1)">mdi-close-circle</v-icon>
          </v-img>
          <v-btn
            v-else
            width="240px"
            height="135px"
            class="ma-2"
            @click="onClickImageSelect(1, image1)"
          >
            {{ label("selectImage") }}
          </v-btn>
          <v-img
            v-if="image2Url"
            :src="image2Url"
            max-width="240px"
            max-height="135px"
            class="ma-2 imageView elevation-2"
          >
            <v-icon class="imageClose" @click="onClearImage(2)">mdi-close-circle</v-icon>
          </v-img>
          <v-btn
            v-else
            width="240px"
            height="135px"
            class="ma-2"
            @click="onClickImageSelect(2, image2)"
          >
            {{ label("selectImage") }}
          </v-btn>
          <v-img
            v-if="image3Url"
            :src="image3Url"
            width="240px"
            max-height="135px"
            class="ma-2 imageView elevation-2"
          >
            <v-icon class="imageClose" @click="onClearImage(3)">mdi-close-circle</v-icon>
          </v-img>
          <v-btn
            v-else
            width="240px"
            height="135px"
            class="ma-2"
            @click="onClickImageSelect(3, image3)"
          >
            {{ label("selectImage") }}
          </v-btn>
        </div>
        <ClientImageSelectDialog :value="selectImageIndex !== null" :imageId="selectedImageId" @select="onSelectImage"
                                 @close="onCloseImageSelectDialog"/>
      </FormItem>
    </v-row>
    <v-row id="jobName">
      <FormItem :name="label('jobName')" example :dialogMsg="label('jobNameSample')" required>
        <TextField
          v-model="name"
          :name="label('jobName')"
          :min="1"
          :max="50"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="jobOccupation">
      <FormItem :name="label('jobOccupation')" required>
        <SelectField
          :name="label('jobOccupation')"
          v-model="jobOccupation"
          :items="consts.jobOccupation"
          :multi="true"
          :max="3"
          required
        />
      </FormItem>
    </v-row>
    <v-row id="jobDetail">
      <FormItem :name="label('jobDetail')" example :dialogMsg="label('jobDetailSample')" required>
        <TextArea
          v-model="detail"
          :name="label('jobDetail')"
          :max="8000"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="所属部署/チーム詳細">
        <TextArea
          v-model="value.assignedDepartmentTeamDetails"
          name="所属部署/チーム詳細"
          :max="1000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="仕事を通じて得られるもの">
        <TextArea
          v-model="value.benefitsFromWork"
          name="仕事を通じて得られるもの"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('techStack')" example :dialogMsg="label('techStackSample')">
        <TextArea
          v-model="techStack"
          :name="label('techStack')"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('mustRequirement')" example :dialogMsg="label('mustRequirementSample')">
        <TextArea
          v-model="mustRequirement"
          :name="label('mustRequirement')"
          :max="1000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('welcomeRequirement')" example :dialogMsg="label('welcomeRequirementSample')">
        <TextArea
          v-model="welcomeRequirement"
          :name="label('welcomeRequirement')"
          :max="1000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('idealPersonType')" example :dialogMsg="label('idealPersonTypeSample')">
        <TextArea
          v-model="idealPersonType"
          :name="label('idealPersonType')"
          :max="1000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="働き方" no-margin-bottom align-label="baseline">
        <div class="mt-n4">
          <RateSlider v-model.number="resourceType" class="mb-4">
            <template v-slot:left>データサイエンティスト（アナリスト）</template>
            <template v-slot:right>機械学習（AI）エンジニア</template>
          </RateSlider>
          <RateSlider v-model.number="developmentType" class="mb-4">
            <template v-slot:left>自社開発</template>
            <template v-slot:right>受託開発</template>
          </RateSlider>
          <RateSlider v-model.number="companyScale" class="mb-4">
            <template v-slot:left>大企業</template>
            <template v-slot:right>ベンチャー</template>
          </RateSlider>
          <RateSlider v-model.number="workingStance" class="mb-4">
            <template v-slot:left>少数のプロジェクトに深く携わる</template>
            <template v-slot:right>多くのプロジェクトに幅広く携わる</template>
          </RateSlider>
        </div>
      </FormItem>
    </v-row>
    <v-form ref="salaryForm">
      <v-row v-if="regular">
        <FormItem :name="label('salary')" required>
          <v-row>
            <v-col cols=3>
              <SalarySelectField
                :label="label('lowerSalary')"
                v-model="lowerSalary"
                :rules="lowerSalaryRules()"
              />
            </v-col>
            <v-col cols=1 class="form-text text-center">
              〜
            </v-col>
            <v-col cols=3>
              <SalarySelectField
                :label="label('upperSalary')"
                v-model="upperSalary"
                :rules="upperSalaryRules()"
              />
            </v-col>
          </v-row>
          <v-row v-if="salaryError" dense class="caption error--text"
                 style="margin-top: -32px; margin-bottom: 32px; margin-left: 16px;">
            {{ salaryError }}
          </v-row>
        </FormItem>
      </v-row>
    </v-form>
    <v-row v-if="regular">
      <FormItem :name="label('salaryMemo')" example :dialogMsg="label('salaryMemoSample')">
        <TextArea
          v-model="salaryMemo"
          :name="label('salaryMemo')"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-form ref="hourlyWageForm">
      <v-row v-if="side">
        <FormItem :name="label('hourlyWage')" required>
          <div class="d-flex flex-row align-baseline">
            <NumberField
              v-model="hourlyWageMin"
              :label="label('hourlyWageMin')"
              :suffix="label('hourlyWageSuffix')"
              :rules="hourlyWageMinRules()"
              style="max-width: 240px;"
              @input="handleInputHourlyWage"
            />
            <div style="margin: 0 16px">〜</div>
            <NumberField
              v-model="hourlyWageMax"
              :label="label('hourlyWageMax')"
              :suffix="label('hourlyWageSuffix')"
              :rules="hourlyWageMaxRules()"
              style="max-width: 240px;"
              @input="handleInputHourlyWage"
            />
          </div>
          <div v-if="hourlyWageError" class="caption error--text"
               style="margin-top: -24px; margin-bottom: 8px; margin-left: 12px;">
            {{ hourlyWageError }}
          </div>
        </FormItem>
      </v-row>
    </v-form>
    <v-form ref="workingHoursWeekForm">
      <v-row v-if="side">
        <FormItem :name="label('workingHoursWeek')" required>
          <div class="d-flex flex-row align-baseline">
            <NumberField
              v-model="workingHoursWeekMin"
              :label="label('workingHoursWeekMin')"
              :suffix="label('workingHoursWeekSuffix')"
              :rules="workingHoursWeekMinRules()"
              style="max-width: 240px;"
              @input="handleInputWorkingHoursWeek"
            />
            <div style="margin: 0 16px">〜</div>
            <NumberField
              v-model="workingHoursWeekMax"
              :label="label('workingHoursWeekMax')"
              :suffix="label('workingHoursWeekSuffix')"
              :rules="workingHoursWeekMaxRules()"
              style="max-width: 240px;"
              @input="handleInputWorkingHoursWeek"

            />
          </div>
          <div v-if="workingHoursWeekError" class="caption error--text"
               style="margin-top: -24px; margin-bottom: 8px; margin-left: 12px;">
            {{ workingHoursWeekError }}
          </div>
        </FormItem>
      </v-row>
    </v-form>
    <v-row v-if="side">
      <FormItem :name="label('workAvailableWeekdayDaytime')">
        <SelectField
          :name="label('workAvailableWeekdayDaytime')"
          v-model="availabilityDaytime"
          :items="workAvailables"
          nullable
        />
      </FormItem>
    </v-row>
    <v-row v-if="side">
      <FormItem :name="label('workAvailableWeekdayEvening')">
        <SelectField
          :name="label('workAvailableWeekdayEvening')"
          v-model="availabilityEvening"
          :items="workAvailables"
          nullable
        />
      </FormItem>
    </v-row>
    <v-row v-if="side">
      <FormItem :name="label('workAvailableHoliday')">
        <SelectField
          :name="label('workAvailableHoliday')"
          v-model="availabilityHoliday"
          :items="workAvailables"
          nullable
        />
      </FormItem>
    </v-row>
    <v-row v-if="side">
      <FormItem :name="label('contractPeriod')">
        <SelectField
          :name="label('contractPeriod')"
          v-model="contractPeriod"
          :items="contractPeriodItems"
          nullable
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem name="リモート可否" required no-margin-bottom>
        <RadioField
          v-model="remoteStatus"
          name="リモート可否"
          row
          :items="[{label: 'フルリモート', value: 1}, {label: '一部リモート', value: 2}, {label: 'リモートなし', value: 3}]"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="workPlace">
      <FormItem :name="label('workPlace')" required>
        <PostalCodeField
          v-model="zipCode"
          :name="label('zipCode')"
        />
        <SelectField
          v-model="prefecture"
          :name="prefectureLabel"
          :items="prefectures"
          required
          :submit="submit"
        />
        <TextField
          v-model="address"
          :name="label('address')"
          :max="100"
          :submit="submit"
        />
        <TextField
          v-model="building"
          :name="label('building')"
          :max="255"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('nearestStation')">
        <TextArea
          v-model="nearestStation"
          :name="label('nearestStation')"
          :max="255"
          simple
          :rows="3"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="employmentStatus" v-if="regular">
      <FormItem :name="label('employmentStatus')" required>
        <SelectField
          :name="label('employmentStatus')"
          v-model="employmentStatus"
          :items="consts.employmentStatus"
          multi
          required
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('workingHours')" required>
        <SelectField
          :name="label('workingHours')"
          v-model="workingHours"
          :items="consts.workingHours"
          :multi="true"
          required
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('workingHoursDetail')">
        <div class="d-flex flex-row">
          <TimeField
            v-model="workingHoursDetailFrom"
          />
          <div class="form-text text-center mx-2">
            〜
          </div>
          <TimeField
            v-model="workingHoursDetailTo"
          />
        </div>
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="時間外労働" align-label="baseline" required>
        <RadioField name="時間外労働" v-model="hasOvertimeWork" row style="margin-top: -34px"
                    :items="[{label: '有り', value: true}, {label: '無し', value: false}]"/>
        <template v-if="hasOvertimeWork.select">
          <TextField
            style="width: 150px;"
            v-model="value.overtimeWork"
            type="number"
            name="時間外労働"
            suffix="時間/月"
            required
            :submit="submit"
          />
          <TextArea
            v-model="value.workHoursOvertimeNotes"
            name="勤務時間/時間外労働に関する補足事項"
            :max="1000"
            :submit="submit"
          />
        </template>
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('companyAppealPoint')">
        <SelectField
          :name="label('companyAppealPoint')"
          v-model="companyAppealPoint"
          :items="consts.companyAppealPoint"
          :multi="true"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="待遇・福利厚生">
        <SelectField
          name="待遇・福利厚生"
          v-model="employeeBenefits"
          :items="consts.employeeBenefit"
          :multi="true"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="その他待遇・福利厚生">
        <TextArea
          v-model="benefit"
          name="その他待遇・福利厚生"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('numRecruit')" example :dialogMsg="label('numRecruitSample')">
        <TextField
          v-model="numRecruit"
          :name="label('numRecruit')"
          :max="50"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="採用プロセス">
        <TextArea
          v-model="value.selectionProcess"
          name="採用プロセス"
          :max="1000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="試用期間" align-label="baseline" required :example="hasProbationPeriod.select"
                dialog-msg="試用期間中の労働条件に変更はありません">
        <RadioField
          style="margin-top: -34px"
          v-model="hasProbationPeriod"
          name="試用期間"
          row
          :items="[{label: '有り', value: true}, {label: '無し', value: false}]"
          :submit="submit"
        />
        <template v-if="hasProbationPeriod.select">
          <TextField
            style="width: 150px;"
            required
            type="number"
            v-model="value.probationPeriod"
            name="試用期間（月数）"
            suffix="ヶ月"
            :submit="submit"
          />
          <TextArea
            v-model="value.probationPeriodNotes"
            name="試用期間に関する補足事項"
            :max="500"
            :submit="submit"
          />
        </template>
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem name="喫煙環境" example dialogMsg="受動喫煙防止措置：屋内禁煙">
        <TextArea
          v-model="value.smokingEnvironment"
          name="喫煙環境"
          :max="500"
          placeholder="制限はありません。"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="regular">
      <FormItem :name="label('specialNotes')">
        <TextArea
          v-model="specialNotes"
          :name="label('specialNotes')"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="side">
      <FormItem :name="label('appealPointSide')">
        <SelectField
          :name="label('appealPointSide')"
          v-model="appealPoints"
          :items="appealPointSides"
          multi
        />
      </FormItem>
    </v-row>
    <v-row v-if="side">
      <FormItem name="その他・特記事項">
        <TextArea
          v-model="specialNotesSide"
          name="その他・特記事項"
          :max="2000"
        />
      </FormItem>
    </v-row>
    <v-expansion-panels v-model="panel" accordion multiple flat>
      <v-expansion-panel flat elevation="0">
        <v-expansion-panel-header class="primary--text title font-weight-bold">
          詳細設定（以下の情報は求人票には掲載されません）
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card rounded elevation="0" color="header"
                  style="padding: 0 20px 0 20px;">
            <v-row class="pt-5" style="margin-left: 0">
              <Label text="スカウト代行設定" size="h6" color="primary" class="font-weight-bold"/>
            </v-row>
            <v-row>
              <FormItem name="スカウト代行機能の利用" no-margin-bottom required>
                <SwitchField v-model="proxyStatus" name="ONにすると詳細設定項目が展開します" hide-details class="mt-0" />
              </FormItem>
            </v-row>
            <template v-if="proxyStatus">
              <v-form>
                <v-row>
                  <FormItem name="送付対象となる年齢">
                    <v-row>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="年齢（下限）"
                          v-model="value.preference.expectedAgeLowerLimit"
                          suffix="歳"
                        />
                      </v-col>
                      <v-col cols=1 class="form-text text-center">
                        〜
                      </v-col>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="年齢（上限）"
                          v-model="value.preference.expectedAgeUpperLimit"
                          suffix="歳"
                        />
                      </v-col>
                    </v-row>
                  </FormItem>
                </v-row>
              </v-form>
              <v-form>
                <v-row>
                  <FormItem name="送付対象となる年収">
                    <v-row>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="年収（下限）"
                          v-model="value.preference.expectedSalaryLowerLimit"
                          suffix="万円"
                        />
                      </v-col>
                      <v-col cols=1 class="form-text text-center">
                        〜
                      </v-col>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="年収（上限）"
                          v-model="value.preference.expectedSalaryUpperLimit"
                          suffix="万円"
                        />
                      </v-col>
                    </v-row>
                  </FormItem>
                </v-row>
              </v-form>
              <v-form>
                <v-row>
                  <FormItem name="送付対象となる学歴" ref="graduatedYearForm">
                    <v-row no-gutters class="mt-n6 mb-4">
                      <v-col v-for="academic in consts.academics" cols="3" :key="academic.id">
                        <v-checkbox v-model="expectedDegrees" :value="academic.value" :label="academic.label" hide-details />
                      </v-col>
                    </v-row>
                  </FormItem>
                </v-row>
              </v-form>
              <v-form>
                <v-row>
                  <FormItem name="送付対象となる卒業年（西暦）" ref="graduatedYearForm">
                    <v-row>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="since"
                          :rules="graduatedYearRules()"
                          v-model.number="value.preference.expectedGraduatedYearSince"
                          suffix="年"
                        />
                      </v-col>
                      <v-col cols=1 class="form-text text-center">
                        〜
                      </v-col>
                      <v-col cols=3>
                        <TextField
                          type="number"
                          name="until"
                          :rules="graduatedYearRules()"
                          v-model.number="value.preference.expectedGraduatedYearUntil"
                          suffix="年"
                        />
                      </v-col>
                    </v-row>
                  </FormItem>
                </v-row>
              </v-form>
              <v-row>
                <FormItem name="候補となるポジション">
                  <SelectField
                    name="候補となるポジション"
                    v-model="value.preference.potentialPosition"
                    :items="consts.currentJob"
                    :multi="true"
                  />
                </FormItem>
              </v-row>
              <v-row>
                <FormItem name="在住の都道府県" info dialogMsg="未選択の場合は、求職者の在住の都道府県に関わらず代行送付されます">
                  <SelectField
                    name="在住の都道府県"
                    v-model="value.preference.residingPrefecture"
                    :items="consts.prefectures"
                    :multi="true"
                  />
                </FormItem>
              </v-row>
              <v-row>
                <FormItem name="スカウトメッセージ" required info dialog-msg="代行スカウトは、同一のスカウトメッセージが送付される点にご留意ください">
                  <TextArea
                    v-model="value.preference.scoutMessage"
                    name="スカウトメッセージ"
                    :max="1000"
                    :submit="submit"
                    required
                  />
                </FormItem>
              </v-row>
              <v-row>
                <FormItem name="スカウト送付者" required>
                  <SelectField
                    v-model="value.preference.requestor"
                    name="スカウト送付者"
                    :items="requestorItems"
                    required
                  />
                </FormItem>
              </v-row>
            </template>
          </v-card>

          <template v-if="value.preference">
            <v-row class="mt-10 mb-n6" style="margin-left: 0">
              <Label text="エージェントへの申し送り事項" size="h6" color="primary" class="font-weight-bold"/>
            </v-row>
            <v-row>
              <FormItem name="実務経験" no-margin-bottom>
                <BoolRadioField
                  name="実務経験"
                  v-model="value.preference.handsOn"
                  :items="[{label: '実務経験必須', value: true}, {label: '実務未経験可', value: false}]"
                  row
                />
              </FormItem>
            </v-row>
            <v-row>
              <FormItem name="アトラクトのポイント（企業）">
                <TextArea
                  v-model="value.preference.companyAttractPoints"
                  name="アトラクトのポイント（企業）"
                  :max="1000"
                  :submit="submit"
                />
              </FormItem>
            </v-row>
            <v-row>
              <FormItem name="アトラクトのポイント（ポジション）">
                <TextArea
                  v-model="value.preference.positionAttractPoints"
                  name="アトラクトのポイント（ポジション）"
                  :max="1000"
                  :submit="submit"
                />
              </FormItem>
            </v-row>
            <v-row>
              <FormItem name="ターゲットイメージ">
                <TextArea
                  v-model="value.preference.targetImage"
                  name="ターゲットイメージ"
                  placeholder="経験企業/スキル/資格/志向性/過去の内定者属性"
                  :max="5000"
                  :submit="submit"
                />
              </FormItem>
            </v-row>
            <v-row>
              <FormItem name="許容される最大転職回数">
                <TextArea
                  v-model="value.preference.numberOfJobChanges"
                  name="許容される最大転職回数"
                  :max="1000"
                  :submit="submit"
                />
              </FormItem>
            </v-row>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import TextField from "../atoms/TextField";
import FormItem from "../molecules/FormItem";
import SelectField from "../atoms/SelectField";
import TextArea from "../atoms/TextArea";
import RequiredItemText from "../atoms/RequiredItemText";
import ComponentMixin from "../ComponentMixin";
import {mapGetters} from "vuex";
import RadioField from "../atoms/RadioField";
import SalarySelectField from "@/components/molecules/SalarySelectField";
import TimeField from "@/components/molecules/TimeField";
import PostalCodeField from "@/components/molecules/PostalCodeField";
import ClientImageSelectDialog from "@/components/organisms/ClientImageSelectDialog";
import ApiMixin from "@/ApiMixin";
import NumberField from "@/components/molecules/NumberField";
import RateSlider from "@/components/atoms/RateSlider";
import BoolRadioField from "@/components/atoms/BoolRadioField.vue";
import Label from "@/components/atoms/Label.vue";
import SwitchField from "@/components/atoms/SwitchField.vue";

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "organism",
  name: "JobForm",
  props: {
    value: {
      type: Object,
      required: true
    },
    sideValues: {
      type: Object,
    },
    type: {
      type: String,
      default: 'regular'
    },
  },
  data() {
    return {
      imageData: null,
      salaryError: null,
      hourlyWageError: null,
      workingHoursWeekError: null,
      selectImageIndex: null,
      selectedImageId: null,
      hasProbationPeriod: {select: false},
      hasOvertimeWork: {select: false},
      proxyStatus: null,
      expectedDegrees: [],
      panel: [],
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    ...mapGetters("client", ["company", "requestors"]),
    requestorItems() {
      if (this.requestors.length === 0 && this.company.id) {
        this.loadRequestors(this.company.id)
      }
      return this.requestors.map(requestor => ({
        label: `${requestor.lastName} ${requestor.firstName}`,
        value: requestor.id
      }))
    },
    image: {
      get() {
        return this.value.image
      },
      set(value) {
        this.$emit("input", {...this.value, image: value})
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(value);
      }
    },
    image1() {
      return this.value.image1;
    },
    image2() {
      return this.value.image2;
    },
    image3() {
      return this.value.image3;
    },
    image1Url() {
      return this.value.image1 ? this.value.image1.url : null;
    },
    image2Url() {
      return this.value.image2 ? this.value.image2.url : null;
    },
    image3Url() {
      return this.value.image3 ? this.value.image3.url : null;
    },
    imageCount() {
      const images = [this.image1, this.image2, this.image3]
      return images.filter(i => i).length
    },
    name: {
      get() {
        return this.value.name === '' || this.value.name === null
          ? undefined
          : this.value.name
      },
      set(value) {
        this.$emit("input", {...this.value, name: value})
      }
    },
    jobOccupation: {
      get() {
        return this.value.occupations
      },
      set(value) {
        this.$emit("input", {...this.value, occupations: value})
      }
    },
    detail: {
      get() {
        return this.value.detail === '' || this.value.detail === null
          ? undefined
          : this.value.detail
      },
      set(value) {
        this.$emit("input", {...this.value, detail: value})
      }
    },
    techStack: {
      get() {
        return this.value.techStack
      },
      set(value) {
        this.$emit("input", {...this.value, techStack: value})
      }
    },
    resourceType: {
      get() {
        return this.value.resourceType;
      },
      set(value) {
        this.$emit("input", {...this.value, resourceType: value})
      }
    },
    developmentType: {
      get() {
        return this.value.developmentType;
      },
      set(value) {
        this.$emit("input", {...this.value, developmentType: value})
      }
    },
    companyScale: {
      get() {
        return this.value.companyScale;
      },
      set(value) {
        this.$emit("input", {...this.value, companyScale: value})
      }
    },
    workingStance: {
      get() {
        return this.value.workingStance;
      },
      set(value) {
        this.$emit("input", {...this.value, workingStance: value})
      }
    },
    zipCode: {
      get() {
        return this.value.zipCode
      },
      set(value) {
        this.$emit("input", {...this.value, zipCode: value})
      }
    },
    prefecture: {
      get() {
        return this.value.prefecture === null ? undefined : this.value.prefecture
      },
      set(value) {
        this.$emit("input", {...this.value, prefecture: value})
      }
    },
    address: {
      get() {
        return this.value.address
      },
      set(value) {
        this.$emit("input", {...this.value, address: value})
      }
    },
    building: {
      get() {
        return this.value.building
      },
      set(value) {
        this.$emit("input", {...this.value, building: value})
      }
    },
    nearestStation: {
      get() {
        return this.value.nearestStation
      },
      set(value) {
        this.$emit("input", {...this.value, nearestStation: value})
      }
    },
    remoteStatus: {
      get() {
        if (this.value.remoteStatus !== null) {
          return {select: this.value.remoteStatus};
        }
        return null
      },
      set(value) {
        this.$emit("input", {...this.value, remoteStatus: value.select})
      }
    },
    mustRequirement: {
      get() {
        return this.value.mustRequirement
      },
      set(value) {
        this.$emit("input", {...this.value, mustRequirement: value})
      }
    },
    idealPersonType: {
      get() {
        return this.value.idealPersonType
      },
      set(value) {
        this.$emit("input", {...this.value, idealPersonType: value})
      }
    },
    welcomeRequirement: {
      get() {
        return this.value.welcomeRequirement
      },
      set(value) {
        this.$emit("input", {...this.value, welcomeRequirement: value})
      }
    },
    lowerSalary: {
      get() {
        return this.value.lowerSalary === null ? undefined : this.value.lowerSalary
      },
      set(value) {
        this.$emit("input", {...this.value, lowerSalary: value})
      }
    },
    upperSalary: {
      get() {
        return this.value.upperSalary === null ? undefined : this.value.upperSalary
      },
      set(value) {
        this.$emit("input", {...this.value, upperSalary: value})
      }
    },
    salaryMemo: {
      get() {
        return this.value.salaryMemo
      },
      set(value) {
        this.$emit("input", {...this.value, salaryMemo: value})
      }
    },
    employmentStatus: {
      get() {
        return this.value.employmentStatus === null ? undefined : this.value.employmentStatus
      },
      set(value) {
        this.$emit("input", {...this.value, employmentStatus: value})
      }
    },
    workingHours: {
      get() {
        return this.value.workingHours === null ? undefined : this.value.workingHours
      },
      set(value) {
        this.$emit("input", {...this.value, workingHours: value})
      }
    },
    workingHoursDetailFrom: {
      get() {
        return this.value.workingHourFrom
      },
      set(value) {
        this.$emit("input", {...this.value, workingHourFrom: value})
      }
    },
    workingHoursDetailTo: {
      get() {
        return this.value.workingHourTo
      },
      set(value) {
        this.$emit("input", {...this.value, workingHourTo: value})
      }
    },
    companyAppealPoint: {
      get() {
        return this.value.companyAppealPoint
      },
      set(value) {
        this.$emit("input", {...this.value, companyAppealPoint: value})
      }
    },
    benefit: {
      get() {
        return this.value.benefit
      },
      set(value) {
        this.$emit("input", {...this.value, benefit: value})
      }
    },
    employeeBenefits: {
      get() {
        return this.value.employeeBenefits
      },
      set(value) {
        this.$emit("input", {...this.value, employeeBenefits: value})
      }
    },
    numRecruit: {
      get() {
        return this.value.numRecruit
      },
      set(value) {
        this.$emit("input", {...this.value, numRecruit: value})
      }
    },
    specialNotes: {
      get() {
        return this.value.specialNotes
      },
      set(value) {
        this.$emit("input", {...this.value, specialNotes: value})
      }
    },
    specialNotesSide: {
      get() {
        return this.sideValues.specialNotes
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, specialNotes: value})
      }
    },
    isDisclosed: {
      get() {
        return this.value.isDisclosed
      },
      set(value) {
        this.$emit("input", {...this.value, isDisclosed: value})
      }
    },
    hourlyWageMin: {
      get() {
        return this.sideValues.hourlyWageMin
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, hourlyWageMin: value})
      }
    },
    hourlyWageMax: {
      get() {
        return this.sideValues.hourlyWageMax
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, hourlyWageMax: value})
      }
    },
    workingHoursWeekMin: {
      get() {
        return this.sideValues.workingHoursWeekMin
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, workingHoursWeekMin: value})
      }
    },
    workingHoursWeekMax: {
      get() {
        return this.sideValues.workingHoursWeekMax
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, workingHoursWeekMax: value})
      }
    },
    availabilityDaytime: {
      get() {
        return this.sideValues.availabilityDaytime
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, availabilityDaytime: value})
      }
    },
    availabilityEvening: {
      get() {
        return this.sideValues.availabilityEvening
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, availabilityEvening: value})
      }
    },
    availabilityHoliday: {
      get() {
        return this.sideValues.availabilityHoliday
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, availabilityHoliday: value})
      }
    },
    contractPeriod: {
      get() {
        return this.sideValues.contractPeriod
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, contractPeriod: value})
      }
    },
    appealPoints: {
      get() {
        return this.sideValues.appealPoints
      },
      set(value) {
        this.$emit("inputSide", {...this.sideValues, appealPoints: value})
      }
    },
    prefectures() {
      return this.consts.prefectures;
    },
    prefectureLabel() {
      return this.label('prefecture');
    },
    regular() {
      return this.type === 'regular'
    },
    side() {
      return this.type === 'side'
    },
    workAvailables() {
      return [
        {label: "実働をお願いしたい", value: 1},
        {label: "連絡だけでOK", value: 2},
        {label: "連絡不可でもOK", value: 3}
      ]
    },
    contractPeriodItems() {
      return [
        {label: "1ヶ月", value: 1},
        {label: "3ヶ月", value: 2},
        {label: "6ヶ月超", value: 3},
      ]
    },
    appealPointSides() {
      return this.consts.jobSideAppealPoint
    }
  },
  watch: {
    lowerSalary() {
      this.$refs.salaryForm.validate()
    },
    upperSalary() {
      this.$refs.salaryForm.validate()
    },
    value: {
      handler(value) {
        if (value) {
          if (value.probationPeriod) {
            this.hasProbationPeriod = {select: true}
          }
          if (value.overtimeWork) {
            this.hasOvertimeWork = {select: true}
          }
          if (this.proxyStatus === null && value.preference) {
            this.proxyStatus = value.preference.proxyStatus
          }
          if (this.expectedDegrees) {
            this.expectedDegrees = value.preference && value.preference.expectedDegrees || []
          }
        }
      },
      immediate: true
    },
    hasProbationPeriod: {
      handler(ele) {
        if (!ele.select) {
          this.value.probationPeriod = null
          this.value.probationPeriodNotes = null
        }
      }
    },
    hasOvertimeWork: {
      handler(ele) {
        if (!ele.select) {
          this.value.overtimeWork = null
          this.value.workHoursOvertimeNotes = null
        }
      }
    },
    proxyStatus: {
      handler(value) {
        this.value.preference.proxyStatus = value
      }
    },
    expectedDegrees: {
      handler(value) {
        console.log('watch expectedDegrees', value)
        this.value.preference.expectedDegrees = value || []
      }
    }
  },
  async mounted() {
    this.salaryError = null
  },
  methods: {
    changePanel (index) {
      this.panel = [index]
    },
    validate() {
      return (
        this.$refs.salaryForm.validate() &&
        this.$refs.hourlyWageForm.validate() &&
        this.$refs.workingHoursWeekForm.validate()
      )
    },
    async handleInputHourlyWage() {
      await this.$nextTick() // v-modelの値更新を待つ
      this.$refs.hourlyWageForm.validate()
    },
    async handleInputWorkingHoursWeek() {
      await this.$nextTick()
      this.$refs.workingHoursWeekForm.validate()
    },
    lowerSalaryRules() {
      return [
        (value) => {
          if (value && this.upperSalary && value > this.upperSalary) {
            this.salaryError = this.error("invalidSalary");
            return "";
          }
          if (!value && !this.upperSalary) {
            this.salaryError = this.error("requireEitherInput");
            return "";
          }
          this.salaryError = null;
          return true;
        }
      ]
    },
    upperSalaryRules() {
      return [
        (value) => {
          if (value && this.lowerSalary && value < this.lowerSalary) {
            this.salaryError = this.error("invalidSalary");
            return "";
          }
          if (!value && !this.lowerSalary) {
            this.salaryError = this.error("requireEitherInput");
            return "";
          }
          this.salaryError = null;
          return true;
        }
      ]
    },
    hourlyWageMinRules() {
      return [
        (value) => {
          if (value && this.hourlyWageMax && value > this.hourlyWageMax) {
            this.hourlyWageError = "時間単価の下限を上限以下に設定して下さい";
            return "";
          }
          if (!value && !this.hourlyWageMax) {
            this.hourlyWageError = this.error("requireEitherInput");
            return "";
          }
          this.hourlyWageError = null;
          return true;
        }
      ]
    },
    hourlyWageMaxRules() {
      return [
        (value) => {
          if (value && this.hourlyWageMin && value < this.hourlyWageMin) {
            this.hourlyWageError = "時間単価の下限を上限以下に設定して下さい";
            return "";
          }
          if (!value && !this.hourlyWageMin) {
            this.hourlyWageError = this.error("requireEitherInput");
            return "";
          }
          this.hourlyWageError = null;
          return true;
        }
      ]
    },
    workingHoursWeekMinRules() {
      return [
        (value) => {
          if (value && this.workingHoursWeekMax && value > this.workingHoursWeekMax) {
            this.workingHoursWeekError = "勤務時間/週の下限を上限以下に設定して下さい";
            return "";
          }
          if (!value && !this.workingHoursWeekMax) {
            this.workingHoursWeekError = this.error("requireEitherInput");
            return "";
          }
          this.workingHoursWeekError = null;
          return true;
        }
      ]
    },
    workingHoursWeekMaxRules() {
      return [
        (value) => {
          if (value && this.workingHoursWeekMin && value < this.workingHoursWeekMin) {
            this.workingHoursWeekError = "勤務時間/週の下限を上限以下に設定して下さい";
            return "";
          }
          if (!value && !this.workingHoursWeekMin) {
            this.workingHoursWeekError = this.error("requireEitherInput");
            return "";
          }
          this.workingHoursWeekError = null;
          return true;
        }
      ]
    },
    graduatedYearRules() {
      return [
        (year) => {
          if (year && year < 1900) {
            return "1900年以降の年を入力してください";
          } else if (year && year > 2100) {
            return "2100年以前の年を入力してください";
          }
          return true;
        },
      ]
    },
    onClickImageSelect(index, image) {
      this.selectedImageId = image ? image.id : null;
      this.selectImageIndex = index;
    },
    onSelectImage(image) {
      if (this.selectImageIndex === 1) {
        this.$emit("input", {...this.value, image1: image})
      }
      if (this.selectImageIndex === 2) {
        this.$emit("input", {...this.value, image2: image})
      }
      if (this.selectImageIndex === 3) {
        this.$emit("input", {...this.value, image3: image})
      }
      this.selectedImageId = null;
      this.selectImageIndex = null;
    },
    onClearImage(index) {
      if (index === 1) {
        this.$emit("input", {...this.value, image1: null})
      }
      if (index === 2) {
        this.$emit("input", {...this.value, image2: null})
      }
      if (index === 3) {
        this.$emit("input", {...this.value, image3: null})
      }
    },
    onCloseImageSelectDialog() {
      this.selectedImageId = null;
      this.selectImageIndex = null;
    },
    submit() {
    },
    resetSideJobErrors() {
      this.hourlyWageError = null
      this.workingHoursWeekError = null
    }
  },
  components: {
    SwitchField,
    Label,
    BoolRadioField,
    RateSlider,
    NumberField,
    ClientImageSelectDialog,
    PostalCodeField,
    TimeField,
    SalarySelectField,
    FormItem,
    TextField,
    SelectField,
    TextArea,
    RequiredItemText,
    RadioField,
  }
}
</script>

<style scoped lang="sass">
.form-text
  line-height: 56px

.imageView
  position: relative
  flex-grow: 0
  border-radius: 4px

  .imageClose
    position: absolute
    top: 8px
    right: 8px
    background-color: white
    border-radius: 50%

.leftLabel
  width: 280px
  text-align: end
  color: rgba(0, 0, 0, 0.54)
  margin-right: 8px

.v-expansion-panel::before
  box-shadow: none !important

.v-expansion-panel
  border: 1px solid rgba(0, 0, 0, 0.2) !important

</style>
